export default __webpack_public_path__ + "static/media/cert-it-cpttm.fead27a2.jpg";